'use strict';
export default class Header {
  constructor() {
    this.name = 'header';
    console.log('%s module', this.name.toLowerCase());
  }
}
